<template>
  <div v-if="!!phaseData && isMounted && phaseData">
    <template v-for="option in familyOptions">
      <radio-options
        :key="option.key"
        :label="option.name"
        class="mt-4"
        v-model="phaseData.profile[option.key].value"
        row
        hide-details
        :options="defaultOptions"
        clearable
        @change="resetObject(option.key)"
      />
      <div v-if="phaseData.profile[option.key].value" :key="option.key + '_checkvalue'">
        <field-label
          v-if="option.options.radioOptions"
          :label="'Grau de parentesco:'"
          :key="option.key + '_wrapper'"
          class="mt-3"
        >
          <div class="d-flex ml-3">
            <div v-for="degree in option.options.radioOptions" :key="option.key + '_' + degree + 'grau'" class="mr-3">
              <v-checkbox
                dense
                :label="degree + ' Grau'"
                :value="degree"
                v-model="phaseData.profile[option.key].degree"
              />
            </div>
          </div>
        </field-label>
        <div v-else :key="option.key + '_wrapper'" class="ml-2 mt-4">
          <field-label v-for="area in option.options.textArea" :key="area.key" :label="area.name">
            <text-area
              :readonly="disabled"
              :placeholder="area.placeholder"
              v-model="phaseData.profile[option.key].complement[area.key]"
            />
          </field-label>
        </div>
      </div>
    </template>

    <field-label class="mt-8" label="Anotações">
      <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" />
    </field-label>
  </div>
</template>
<script>
import FieldLabel from '@/components/FieldLabel.vue'
import RadioOptions from '@/components/RadioOptions.vue'
import TextArea from '@/components/TextArea.vue'
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'

import { FAMILY_HISTORY } from '@/components/AttendanceForm/csu/constants/familyHistory'

export default {
  components: { FieldLabel, TextArea, RadioOptions },
  extends: BasePhase,
  computed: {
    defaultOptions() {
      return [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ]
    },
  },
  data() {
    return {
      isMounted: false,
      familyOptions: FAMILY_HISTORY,
    }
  },
  methods: {
    getDefaultData() {
      const data = {
        profile: this.buildEmptyProfile(),
        notes: null,
      }
      return data
    },

    buildEmptyProfile() {
      return this.familyOptions.reduce(
        (acc, option) =>
          option.key === 'doenca_reumatologia'
            ? { ...acc, [option.key]: { value: null, complement: { qual_doenca: null, tratamentos: null } } }
            : { ...acc, [option.key]: { value: null, degree: [] } },
        {},
      )
    },

    resetObject(key) {
      if (!this.phaseData.profile[key].value) {
        if (this.phaseData.profile[key].degree) {
          this.phaseData.profile[key].degree = []
        } else {
          this.phaseData.profile[key].complement = { qual_doenca: null, tratamentos: null }
        }
      }
    },
  },
  mounted() {
    this.isMounted = true
  },
}
</script>

<style scoped></style>
